<template>
  <CModal
    v-model:visible="showModal"
    :size="'sm'"
    centered
    @close="closeModal"
  >
    <template #header-wrapper>
      <CCardHeader>
        <h4 class="font-weight-bold text-center mb-0">
          Are you sure?
        </h4>
      </CCardHeader>
    </template>
    <CCardBody class="pt-3 pb-0">
      <p class="text-center mb-0">
        {{ message }}
      </p>
      <div class="d-flex mt-4 mb-3 align-items-center justify-content-center">
        <CButton
          color="secondary"
          class="mx-auto text-uppercase"
          @click="showModal = false"
        >
          Cancel
        </CButton>
        <CButton
          color="danger"
          class="mx-auto text-uppercase btn_yes"
          @click="confirmAction()"
        >
          Yes
        </CButton>
      </div>
    </CCardBody>
    <template #footer-wrapper>
      <span />
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'ConfirmActionModal',
  data() {
    return {
      showModal: false,
      payload: null,
      message: 'Do you really want to perform this action?',
    };
  },
  methods: {
    open(payload, customMessage = null) {
      this.payload = payload;
      if (customMessage) {
        this.message = customMessage;
      }
      this.showModal = true;
    },
    confirmAction() {
      this.showModal = false;
      this.$emit('confirmed', this.payload);
      this.payload = null;
    },
    closeModal() {
      this.$emit('modal:close');
    },
  },
};
</script>
